export default [
  {
    path: '/user-login',
    component: () => import('@/views/user/Login.vue'),
    name: 'login',
    meta: {
      title: '登录',
      backgroundClass: 'bg-login',
    },
    hidden: true,
  },
];
